export default __webpack_public_path__ + "static/media/ISEO CLASS 4 SYLLABUS.2408040d.pdf";